
/* ==========================================================================\n   DEBUG PERFORMANCE HELPERS (/database/js/runtime-perf.js)\n\n   New-file module so optimization instrumentation never requires adding named\n   exports to the long-lived runtime.js module during a rolling/cache-mixed deploy.\n   ========================================================================== */

function diagnosticsEnabled() {
  if (typeof window === 'undefined') return false;
  try {
    return window.localStorage?.getItem('sff-debug') === '1' ||
      /(?:^|[?&])sff_debug=1(?:&|$)/.test(window.location?.search || '');
  } catch (_) {
    return false;
  }
}

export function runtimeNow() {
  return typeof performance !== 'undefined' && typeof performance.now === 'function'
    ? performance.now()
    : Date.now();
}

export function debugPerformanceMetric(scope, startedAt, details = null) {
  if (!diagnosticsEnabled()) return 0;
  const elapsed = Math.max(0, runtimeNow() - Number(startedAt || 0));
  if (details && typeof details === 'object') console.debug(`[SFF PERF] ${scope}: ${elapsed.toFixed(2)}ms`, details);
  else console.debug(`[SFF PERF] ${scope}: ${elapsed.toFixed(2)}ms`);
  return elapsed;
}

export function scheduleIdleTask(callback, timeout = 1500) {
  if (typeof callback !== 'function') return null;
  if (typeof requestIdleCallback === 'function') {
    return requestIdleCallback(() => callback(), { timeout: Math.max(0, Number(timeout) || 0) });
  }
  return setTimeout(callback, Math.min(250, Math.max(0, Number(timeout) || 0)));
}
